var React = require('react');

function WebsiteWithBracketsInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30.5 9V0H0.5V9H30.5ZM24.5 3H27.5V6H24.5V3ZM3.5 3H21.5V6H3.5V3Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M0.5 12V30H30.5V12H0.5ZM14.028 23.528L11.732 25.456L7.996 21L11.724 16.544L14.02 18.472L11.908 21L14.028 23.528ZM19.268 25.456L16.972 23.528L19.092 21L16.972 18.472L19.268 16.544L22.996 21L19.268 25.456Z","fill":"currentColor","key":1})]);
}

WebsiteWithBracketsInline.defaultProps = {"width":"31","height":"30","viewBox":"0 0 31 30","fill":"none"};

module.exports = WebsiteWithBracketsInline;

WebsiteWithBracketsInline.default = WebsiteWithBracketsInline;
